// extracted by mini-css-extract-plugin
module.exports = {"SwipeLeftToClose":"xi_a zu_bk zu_bl zu_bo","SwipeLeftToClose--animating":"xi_b"};